import * as d3 from 'd3';
import React from 'react';

import { MarkerData } from '../Markers/types';

export interface ZoomScaleProviderState {
  zoom?: d3.ZoomBehavior<SVGSVGElement, unknown>;
  x?: d3.ScaleLinear<number, number>;
  zoomRef?: React.RefObject<SVGSVGElement>;
  zoomRefCallback?: (dom: SVGSVGElement | null) => void;
  zoomTransform?: d3.ZoomTransform;
  zoomScale: d3.ScaleLinear<number, number> & d3.ZoomScale;
  width?: number;
  setZoomFocusAt?: (datum: MarkerData) => void;
  rescaleAndTranslate?: ({
    parentEl,
    newZoomValue,
    cursorOffset,
  }: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentEl: d3.Selection<any, any, any, any>;
    newZoomValue: number;
    cursorOffset: number;
  }) => void;
}

export const ZoomScaleProviderContext = React.createContext<ZoomScaleProviderState>(
  {} as ZoomScaleProviderState
);
